var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogotypeYoutubeM(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logotype_youtube_m"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1163 3.70668C17.923 3.91251 18.558 4.51668 18.7747 5.28501C19.1647 6.67668 19.1663 9.58334 19.1663 9.58334C19.1663 9.58334 19.1663 12.4892 18.7747 13.8817C18.558 14.65 17.923 15.2542 17.1163 15.46C15.653 15.8333 9.99967 15.8333 9.99967 15.8333C9.99967 15.8333 4.34551 15.8333 2.88301 15.46C2.07634 15.2542 1.44134 14.65 1.22467 13.8817C0.833008 12.49 0.833008 9.58334 0.833008 9.58334C0.833008 9.58334 0.833008 6.67751 1.22467 5.28501C1.44134 4.51668 2.07634 3.91251 2.88301 3.70668C4.34634 3.33334 9.99967 3.33334 9.99967 3.33334C9.99967 3.33334 15.6538 3.33334 17.1163 3.70668ZM13.333 9.58334L8.33301 12.5V6.66668L13.333 9.58334Z",
    fill: "#70707A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogotypeYoutubeM);
export default __webpack_public_path__ + "static/media/logotype_youtube_m.d6b3646978093136c0795e93af0b9ca7.svg";
export { ForwardRef as ReactComponent };